import { getExchangeRate } from "@services/index";
import { useSelector } from "react-redux";
import {
  ETH,
  ETHX,
  SFRXETH,
  STETH,
  WETH,
  WETHE,
  WSTETH,
  SBUSD,
} from "@config/contractsConfig";
import { useQuery } from "@tanstack/react-query";
import useDepositEstimate from "./useDepositEstimate";
import { formatNumber } from "@lib/utils";
import { MAX_FRACTION_DIGITS } from "@constants/common";

export type ERDataType = {
  exchangeRate: number | undefined;
};

const APPOVED_ERC20 = [ETHX, ETH, STETH, SFRXETH];

const useExchangeRate = (variant = "dapp") => {
  const {
    selectedERC20,
    selectedERC20Vault,
    selectedERC20YieldVault,
    selectedERC20StableVault,
    selectedERC20Cryptanium,
  } = useSelector((state: any) => state.user);

  const { returns: wstETHExchangeRate } = useDepositEstimate("1");
  const { returns: wETHExchangeRate } = useDepositEstimate("1");
  const { returns: wETHEExchangeRate } = useDepositEstimate("1");
  const { returns: sBUSDExchangeRate } = useDepositEstimate("1");
  const getSelectedAsset = () => {
    if (variant === "vault") return selectedERC20Vault;
    if (variant === "yieldvault") return selectedERC20YieldVault;
    if (variant === "stablevault") return selectedERC20StableVault;
    if (variant === "cryptaniumvault") return selectedERC20Cryptanium;
    if (variant === "ethRsEth") return ETH;
    return selectedERC20;
  };
  const selected = getSelectedAsset();

  const exchangeRateWstETH = Number(wstETHExchangeRate)
    ? formatNumber(
        Number(1 / +wstETHExchangeRate),
        false,
        MAX_FRACTION_DIGITS,
        true
      )
    : null;

  const exchangeRateWETH = Number(wETHExchangeRate)
    ? formatNumber(
        Number(1 / +wETHExchangeRate),
        false,
        MAX_FRACTION_DIGITS,
        true
      )
    : null;

  const exchangeRateWETHE = Number(wETHEExchangeRate)
    ? formatNumber(
        Number(1 / +wETHEExchangeRate),
        false,
        MAX_FRACTION_DIGITS,
        true
      )
    : null;

  const exchangeRateSBUSD = Number(sBUSDExchangeRate)
    ? formatNumber(
        Number(1 / +sBUSDExchangeRate),
        false,
        MAX_FRACTION_DIGITS,
        true
      )
    : null;

  const { data: exchangeRateData } = useQuery({
    queryKey: ["exchange-rate", selected],
    queryFn: async () => {
      const r = await getExchangeRate(selected);
      return r.data;
    },
    enabled: APPOVED_ERC20.includes(selected),
    refetchInterval: 10_000,
  });

  return {
    exchangeRate:
      selected === WSTETH
        ? exchangeRateWstETH
        : selected === WETH
        ? exchangeRateWETH
        : selected === WETHE
        ? exchangeRateWETHE
        : selected === SBUSD
        ? exchangeRateSBUSD
        : exchangeRateData?.value,
  };
};

export default useExchangeRate;
